<template>
<div>
	<div v-for="(file,index) in fileList" class="iFiles mrX5 relative fl" :class="{circle:circle}">
		<img :src="file" :width="px" :height="px" />
		<div class="iFileH" :style="styles" v-if="!disabled">
		<Icon class="pointer" type="ios-trash" size="20" @click="handleDel(index)"></Icon></div>
	</div>
    <Upload v-if="fileList.length<size&&!disabled" ref="upload" type="drag" class="fl" action="" :multiple="multiple" :before-upload="handleUpload">
		<div :style="styles">
			<Icon type="ios-camera" size="20"></Icon>			
		</div>
	</Upload>
</div>
</template>
<style scoped>
.iFiles {border: 1px dashed #dcdee2;border-radius: 4px;overflow:hidden;}
.iFiles.circle {border-radius:50%;}
.iFiles img {vertical-align: top}
.iFileH {position:absolute;top:0;left:0;text-align:center;background-color: rgba(0, 0, 0, 0.5);display:none;color:#fff;}
.iFiles:hover {border-color:#f00;}
.iFiles:hover .iFileH {display:block;}
</style>
<script>
export default {
    name: 'Upimg',
    props: {
		px: {
			type: Number,
			default: 55
		},
		size: {
			type: Number,
			default: 1
		},
		circle: {
			type: Boolean,
			default: false
		},
		multiple: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		format: {
			type: Array,
			default: () => (['jpg','jpeg','png','bmp'])
		},
		maxSize: {
			type: Number,
			default:1024
		},
		list: {
			type: Array,
			default: () => ([])
		},
    },
	data () {
		return {
			fileList:[]
		}
	},	
	watch: {
		'fileList' (fileList) {
			this.$emit('callback', fileList);
		},
		'list' (list){
			this.handleInit(list)
		}
	},
	mounted(){
		this.handleInit(this.list)
	},
	computed: {
		styles(){
			return {
				'width':this.px+'px',
				'height':this.px+'px',
				'line-height':this.px+'px'
			};
		}
	},
	methods: {
		handleInit(list){
			this.fileList=list;
		},
		handleUpload(file){			
			if(this.handleFormat(file.type)) return this.handleError('文件格式不正确');
			if(this.handleSize(file.size)) return this.handleError('文件太大');
			let _this = this;
			let reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = function (event) {
				let e = event || window.event;
				if(_this.fileList.length>=_this.size) return;
				_this.fileList.push(e.target.result);
			}
			return false;
		},
		handleDel(index){
			this.fileList.splice(index,1)
		},
		handleFormat(str){
			let type = str.split('/').pop();
			const format = this.format;
			for(var i=0;i<format.length;i++){
				if(format[i]==type) return false;
			}
			return true;
		},
		handleSize(num){
			if(num/1024<this.maxSize) return false;
			return true;
		},
		handleError(msg){
			this.$Message.error({content:msg,closable: true});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/inc/component/up-img.vue